module.exports = __webpack_public_path__ + "static/media/moraine-43.51670889.jpg";